import { FormErrors } from '../modules/FormErrors';

class NewsletterForm {
    constructor(root) {
        this.root = root;
        if (!this.root) return;

        this.init();
    }

    init() {
        this.parent = this.root.parentElement;
        this.loader = this.root.querySelector('.loader');

        this.formErrors = new FormErrors(this.root);
        this.recaptchaKey = this.root.querySelector(
            '[name="g_recaptcha_key"]'
        )?.value;

        this.newsletterOutput = this.parent.querySelector(
            '[js-newsletter-output]'
        );
        this.newsletterOutputIcon = this.newsletterOutput?.querySelector(
            '[js-newsletter-output-icon]'
        );
        this.newsletterOutputHeading = this.newsletterOutput?.querySelector(
            '[js-newsletter-output-heading]'
        );
        this.newsletterOutputDescription = this.newsletterOutput?.querySelector(
            '[js-newsletter-output-description]'
        );

        this.events();
    }

    events() {
        this.root.addEventListener('submit', this.onFormSubmit.bind(this));
    }

    async onFormSubmit(e) {
        e.preventDefault();
        try {
            const formData = new FormData(this.root);
            this.formErrors.clearErrors();
            this.loader.classList.add('active');

            grecaptcha.ready(() => {
                grecaptcha
                    .execute(this.recaptchaKey, { action: 'submit' })
                    .then(async token => {
                        formData.append('g_recaptcha_token', token);
                        formData.append('referer_site', window.location.href);

                        const req = await fetch(ajax.url, {
                            method: 'POST',
                            body: formData,
                        });

                        const res = await req.json();
                        const { data, success } = res;

                        if (!success && data.fields) {
                            const { fields } = data;
                            for (const [key, value] of Object.entries(fields)) {
                                this.formErrors.handleFieldError(
                                    key,
                                    true,
                                    value
                                );
                            }
                        } else {
                            res.data.status = success ? 'success' : 'error';
                            this.handleFormOutput(res.data);
                        }
                    });
            });
        } catch (error) {
            console.log(error);
        } finally {
            this.loader.classList.remove('active');
        }
    }

    handleFormOutput(data) {
        this.root.classList.add('hidden');
        this.newsletterOutput.classList.add(`-${data.status}`);
        this.newsletterOutputIcon.classList.remove('icon-check', 'icon-close');
        const isSuccess = data.status === 'success';
        this.newsletterOutputIcon.classList.add(
            isSuccess ? 'icon-check' : 'icon-close'
        );

        this.newsletterOutputHeading.textContent = data.heading
            ? data.heading
            : isSuccess
            ? phrases.newsletter.heading.success
            : phrases.newsletter.heading.error;
        this.newsletterOutputDescription.textContent = data.message ?? '';
    }
}

const elements = document.querySelectorAll('[js-newsletter-form]');

if (elements.length) {
    elements.forEach(element => {
        new NewsletterForm(element);
    });
}
